export const modalBodyleftInformation = [
    {
        key: 'known', title: 'Known', pre: 'Since ', info: 'createdAt', link: '', from: '',
    },
    {
        key: 'birthday', title: 'Birthday', pre: '', info: 'birthday', link: '', from: '',
    },
    {
        key: 'email', title: 'Email', pre: '', info: 'primaryEmail', link: '/my-network/', from: '',
    },
    {
        key: 'email2', title: 'Email 2', pre: '', info: 'secondaryEmail', link: '/my-network/', from: '',
    },
    {
        key: 'phone', title: 'Phone', pre: '', info: 'primaryPhone', link: '', from: '',
    },
    {
        key: 'brief', title: 'Brief', pre: '', info: 'primaryBrief', link: '/my-network/', from: '',
    },
];

export const mockedStatistics = [
    {
        key: 'interactions',
        title: 'Interactions',
        value: 'interactions',
    },
    {
        key: 'emails',
        title: 'Emails',
        value: 'totalEmails',
    },
    {
        key: 'meetings',
        title: 'Meetings',
        value: 'meetings',
    },
];
